import { Label } from '@packages/shared/src/ui/Label/Label';

type NameProps = {
  mandatory: boolean;
  name: string;
  id: string;
};

/**
 * atom for Aplus - renders the service name as plain text or a clickable label.
 */
export const Name = ({ mandatory, name, id }: NameProps) =>
  mandatory ? (
    name
  ) : (
    <Label htmlFor={id} className="cursor-pointer">
      {name}
    </Label>
  );
